import { render } from "./sideMenu.vue?vue&type=template&id=e8d20d74&scoped=true"
import script from "./sideMenu.vue?vue&type=script&lang=js"
export * from "./sideMenu.vue?vue&type=script&lang=js"

import "./sideMenu.vue?vue&type=style&index=0&id=e8d20d74&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8d20d74"]])

export default __exports__